<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-4 text-center text-lg-start alignFix posRel">
          <div class="assistant">
            <div class="row assHead g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
              <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
              </div>
            </div>
            <div class="row assContent g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
              <div class="col-10 txt"> Hey ciao! 👋 <br>
                Inizia compilando i primi dati relativi al volo. Li tratteremo con cura 😉 Per qualunque dubbio durante la compilazione clicca sull'icona ❓</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 bgWight formStyle posRel">
          <div class="headForm">
            <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
          </div>
          <div class="p-4 p-md-4 ">
            <div class="row g-2">
              <div class="form-floating mb-3 col-md-6 fixLabel">
                <div class="g-2">{{ $t('message.st1_compagnia_aerea') }} *</div>
                <v-select :options="compagnie_options" label="nome"
                          v-model="compagnia" v-bind:placeholder="$t('message.st1_compagnia_aerea')"
                          v-bind:class="[v$.compagnia.required.$invalid && showerrors ? 'form-error' : '']"></v-select>
                <div class="error" v-if="v$.compagnia.required.$invalid && showerrors">{{ $t("message.st1_scegliere_compagnia") }}</div>
              </div>
              <div class="col-md-6">
                <div class="form-floating mb-3 fixLabel ">
                  <div class="g-2">N° volo *<a href="#infoVolo" data-bs-toggle="modal" data-target="#infoVolo"><span class="infoFix">?</span></a></div>
                  <input type="text" v-maska v-bind:data-maska="prefix" class="form-control " id="volo" v-model="numerovolo" placeholder="Inserisci numero volo"
                         v-bind:class="[(v$.numerovolo.required.$invalid) && showerrors ? 'form-error' : '']">
                  <label for="volo">{{ $t('message.gen_numero_volo') }}</label>
                  <div class="error" v-if="v$.numerovolo.required.$invalid && showerrors">{{ $t("message.st1_numero_volo_required") }}</div>
                  <div class="error" v-if="numerovolononvalido">{{ $t("message.st1_numero_volo_nonvalido") }}</div>
                </div>
              </div>
            </div>
            <div class="form-floating mb-3 fixLabel">
              <div class="g-2">{{ $t('message.st1_partenza_label') }} *</div>
              <v-select id="partenza" :filterable="false" :options="aeroporti_options"
                        @search="onAeroportiSearch"
                        class="u-border-1 u-border-custom-color-5 u-custom-color-6 u-input-min u-input-rectangle u-radius-3"
                        v-model="partenza" label="text"
                        v-bind:placeholder="$t('message.st1_partenza')"
                        v-bind:class="[v$.partenza.required.$invalid && showerrors ? 'form-error' : '']">
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <span style="color: red"> {{ $t("message.aerop_nessun_risultato") }} <em><strong>{{search}}</strong></em></span>
                  </template>
                  <em v-else style="opacity: 0.5">{{ $t("message.st1_cerca_aeroporto")
                    }}</em>
                </template>
                <template v-slot:options="option">
                  <div class="d-center">
                    {{ option.text }}
                  </div>
                </template>
                <template v-slot:selected-option="option">
                  <div class="selected d-center">
                    {{ option.text }}
                  </div>
                </template>
              </v-select>
              <div class="error"
                   v-if="v$.partenza.required.$invalid && showerrors">{{
                  $t("message.st1_partenza_required") }}
              </div>
            </div>
            <div class="form-floating mb-3 fixLabel">
              <div class="g-2">{{$t('message.st1_destinazione_label')}}  *</div>
              <v-select id="destinazione" :filterable="false" :options="aeroporti_options"
                        @search="onAeroportiSearch" name="text-3"
                        class="u-border-1 u-border-custom-color-5 u-custom-color-6 u-input-min u-input-rectangle u-radius-3"
                        v-model="destinazione" label="text"
                        v-bind:placeholder="$t('message.st1_destinazione')"
                        v-bind:class="[v$.destinazione.required.$invalid && showerrors ? 'form-error' : '']">
                >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <span style="color: red"> {{ $t("message.aerop_nessun_risultato") }} <em><strong>{{search}}</strong></em></span>
                  </template>
                  <em v-else style="opacity: 0.5">{{ $t("message.st1_cerca_aeroporto")
                    }}</em>
                </template>
                <template v-slot:options="option">
                  <div class="d-center">
                    {{ option.text }}
                  </div>
                </template>
                <template v-slot:selected-option="option">
                  <div class="selected d-center">
                    {{ option.text }}
                  </div>
                </template>
              </v-select>
              <div class="error"
                   v-if="v$.destinazione.required.$invalid && showerrors">{{
                  $t("message.st1_destinazione_required") }}
              </div>
            </div>
            <div class="row g-3 ">
              <div class="col-md-4 order-md-3">
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">{{ $t("message.gen_btn_avanti") }}</button>
              </div>
              <div class="col-md-4 order-md-1">
                <p class="txtFooForm"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/trustpilot-2.svg">Trustpilot 4,9/5 Eccezionale</p>
              </div>
              <div class="col-md-4 order-md-2">
                <p class="txtFooForm"><img class="cuffieAssistenza" src="https://www.rimborsoalvolo.it/cresources/outform/images/cuffieAssistenza.png" alt="">Assistenza telefonica.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <trust-pilot></trust-pilot>
  <conteggio-reclami></conteggio-reclami>
  <recensioni-f-b></recensioni-f-b>
  <sezione-a-p-r-a></sezione-a-p-r-a>
  <page-footer></page-footer>
  <popup-numero></popup-numero>
  <popup-avviso-detrazione
      @condizioni-accettate="condizioniDetrazioneAccettate"
      @condizioni-rifiutate="condizioniDetrazioneRifiutate"
  ></popup-avviso-detrazione>
</template>

<script>
import vSelect from "vue-select";
import {mapGetters, useStore} from "vuex";
import {loadCompagnie, cercaAeroporto} from "@/lib/flightutils";
import _ from 'lodash';
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {computed} from "vue";
import ModalHintVolo from "@/components/ModalHintVolo";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import {verificaStep} from "@/lib/verificaStep";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import PopupNumero from "@/components/PopupNumero";
import PopupAvvisoDetrazione from "@/components/PopupAvvisoDetrazione.vue";
import { vMaska } from "maska"

export default {
  directives: { maska: vMaska },
  setup(){
    const store = useStore();
    const s_compagnia = computed(()=>store.state.volo.compagnia);
    const s_partenza = computed(()=>store.state.volo.partenza);
    const s_destinazione = computed(()=>store.state.volo.destinazione);
    const s_numerovolo = computed(()=>store.state.volo.numerovolo);
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_step1_inviato = computed( ()=>store.state.gtmstate.step1inviato);
    return {
      s_compagnia,
      s_numerovolo,
      s_partenza,
      s_destinazione,
      s_completati,
      s_step1_inviato,
      ...mapGetters({"getCompagnie":"volo/getCompagnie"}),
      v$: useVuelidate(),
      setPartenza : function(partenza){
        store.dispatch('volo/commitSetPartenza',partenza);
      },
      setDestinazione: function(destinazione){
        store.dispatch('volo/commitSetDestinazione',destinazione);
      },
      setNumeroVolo: function(numerovolo){
        store.dispatch('volo/commitNumeroVolo',numerovolo);
      },
      setCompagnia: function(compagnia){
        store.dispatch('volo/commitCompagnia',compagnia)
      },
      setDataLimitataOttobre2021: function(value){
        store.dispatch('volo/commitDataLimitataOttobre2021',value);
      },
      setStepCompletato: function(){
        store.dispatch('compilazione/commitSetStepCompletato',1);
      },
      setStep1Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio1',true);
      }
    }
  },
  data(){
    return {
      compagnie_options: this.s_partenza != null ? [this.s_partenza,this.s_destinazione] : [],
      aeroporti_options: this.s_partenza != null ? [this.s_partenza,this.s_destinazione] : [],
      compagnia: this.s_compagnia != null ? this.s_compagnia : null,
      partenza : this.s_partenza != null ? this.s_partenza : null,
      destinazione: this.s_destinazione != null ? this.s_destinazione : null,
      numerovolo: this.s_numerovolo != null ? this.s_numerovolo : null,
      showerrors : false,
      dataLimitataAOttobre2021: false,
      showVoloHint:false,
      numerovolononvalido : false,
      prefix: null,
      accettazioneDetrazione: false,
      tempModal: null,
    }
  },
  validations(){
    return {
      partenza: { required },
      destinazione: { required },
      numerovolo: { required},
      compagnia : {required}
    }
  },
  components:{
    PopupAvvisoDetrazione,
    PopupNumero,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
    FakeChat,
    vSelect,
    ModalHintVolo
  },
  name: 'PrimoStep',
  props: {
    msg: String
  },
  methods: {
    async submit(){
      const valid = await this.v$.$validate();
      if(!valid){
        this.showerrors = true;
        return;
      }

      if(!this.verificaNumeroVolo()){
        this.numerovolononvalido = true;
        this.showerrors = true;
        return;
      }else {
        this.numerovolononvalido = false;
      }

      if(this.compagnia.id == 34 && !this.accettazioneDetrazione){
        if(this.tempModal === null ){
          this.tempModal = new bootstrap.Modal(document.getElementById("infoDetrazione"));
        }
        this.tempModal.show();
        return;
      }


      this.salvaDati();
      this.prossimoStep();
    },
    showVoloModal(){
      this.showVoloHint = true;
    },
    closeModal(){
      this.showVoloHint = false;
    },
    condizioniDetrazioneAccettate(){
      this.accettazioneDetrazione = true;
      if(this.tempModal !== null) this.tempModal.hide();
    },
    condizioniDetrazioneRifiutate(){
      this.accettazioneDetrazione = false;
      this.$gtm.trackEvent({
            event: 'rifiutopopupryanair',
            value: 1,
          }
      );
      window.location.reload();
    },
    prossimoStep(){
      this.setStepCompletato();
      this.$router.push({name:'step2'});
    },
    salvaDati(){
      this.setPartenza(this.partenza);
      this.setDestinazione(this.destinazione);
      this.setNumeroVolo(this.numerovolo);
      this.setCompagnia(this.compagnia);
      this.setDataLimitataOttobre2021(this.dataLimitataAOttobre2021);
    },
    onAeroportiSearch(search, loading) {
      this.aeroporti_options = [];
      loading(true);
      this.search(loading, search, this);
    },
    verificaNumeroVolo(){
      if(this.numerovolo === null || this.numerovolo === '') return false;
      if(this.numerovolo.indexOf(this.compagnia.codicecompagnia) < 0) return false;
      let verifica  = this.numerovolo.replace(this.compagnia.codicecompagnia,"");
      return verifica.length === 4;
    },
    search: _.debounce((loading, search, vm)=>{
      if(encodeURI(search)==='' || search.length < 3) {
        loading(false);
        return;
      }
      cercaAeroporto(search).then(function(data){
          vm.aeroporti_options = data;
          loading(false);
      }).catch((err)=>{
        loading(false);
        console.log(err);
      })

    },350),
  },
  mounted() {
    this.$root.$i18n.locale = this.$route.params.locale;
    loadCompagnie().then((compagnie)=>{
      this.compagnie_options = compagnie;
    });


    let step = verificaStep([...this.s_completati]);
    if(step.step > 4) {this.$router.push({name:'step5'});}

    window.scrollTo(0,0);


    try {
      console.log('effettuo check')
      let mt_iub_check = document.querySelector('meta[name="RAV_IUB_PURPOSE"]').getAttribute("content");
      if (typeof fbq == 'undefined' && mt_iub_check.includes('4')) {
        console.log('check 1')
        dataLayer.push({event:"iubenda_consent_given_purpose_4"});
      }
    }catch(e) {

    }

    if( !this.s_step1_inviato) {
      this.setStep1Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 1,
          }
      );

      if(typeof fbq !== 'undefined') {
        fbq('track','PageView');
        fbq('trackCustom','Step1');
      }
    }

  },
  watch:{
    compagnia:function(value){
      this.dataLimitataAOttobre2021 = value.id === 61 || value.id === 164;
      this.numerovolo = value.codicecompagnia;
      this.prefix = value.codicecompagnia + "####";
      if(value.id === 34 || value.id === 43) {
        this.$gtm.trackEvent({
              event: 'ryanairselezionato',
              value: 1,
            }
        );
        this.tempModal = new bootstrap.Modal(document.getElementById("infoDetrazione"));
        this.tempModal.show();
      }
    },
    numerovolo:function(value){
      if(this.compagnia === null || value === null || value === '') return;
      if(value.indexOf(this.compagnia.codicecompagnia) < 0){
        this.numerovolo = this.compagnia.codicecompagnia;
        this.numerovolononvalido = true;
      }else if (value.substr(this.compagnia.codicecompagnia.length,value.length).length !== 4){
        this.numerovolononvalido = true;
      }
      else if (value.substr(this.compagnia.codicecompagnia.length,value.length).length === 4){
        this.numerovolononvalido = false;
      }
    },
    s_destinazione:function(value){
      this.destinazione = value;
    },
    s_partenza:function(value){
      this.partenza = value;
    }
  }
}
</script>

<style scoped>
@import "vue-select/dist/vue-select.css";
.vs__search {
  min-height: 48px !important;
}

.vs__search, .vs__search:focus {
  min-height: 48px !important;
}

</style>
